var _path, _line, _line2, _line3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterOne10(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1 1H1.7C1.3134 1 1 1.3134 1 1.7V14.3C1 14.6866 1.3134 15 1.7 15H17.1C17.4866 15 17.8 14.6866 17.8 14.3V1.7C17.8 1.3134 17.4866 1 17.1 1Z",
    stroke: "#3B4443",
    strokeWidth: 1.12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 9.39984,
    y1: 1,
    x2: 9.39984,
    y2: 14.44,
    stroke: "#3B4443",
    strokeWidth: 1.12
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 17.8008,
    y1: 6.03998,
    x2: 9.96078,
    y2: 6.03998,
    stroke: "#3B4443",
    strokeWidth: 1.12
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 17.8008,
    y1: 10.52,
    x2: 9.96078,
    y2: 10.52,
    stroke: "#3B4443",
    strokeWidth: 1.12
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterOne10);
export default __webpack_public_path__ + "static/media/footer-one-10.8f9b67124c174afe575a64cbf1ee319c.svg";
export { ForwardRef as ReactComponent };